/**
 * User-visible copy for multi-instance Small UPS list + per-unit editor (#996 Phase 1).
 * Mirrors rackConfigurationsSubsectionCopy.
 */

export const SMALL_UPS_CONFIGURATIONS_LIST_TITLE = 'Small UPS units';

export const SMALL_UPS_CONFIGURATIONS_LIST_SUBTITLE =
  'Each row is one small UPS configuration. Select a row to edit, or add a new unit below.';

export const SMALL_UPS_EMPTY_STATE_TITLE = 'No Small UPS added yet';

export const SMALL_UPS_EDIT_DETAILS_CARD_SUBTITLE =
  'Manufacturer, model, electrical inputs, capacity, runtime, mounting, and outlets for this unit.';

export const SMALL_UPS_EDIT_ALL_UNITS_LABEL = 'All Small UPS';

export const SMALL_UPS_EDIT_HEADER_TITLE_NEW = 'New Small UPS';

export const SMALL_UPS_EDIT_STATUS_EXISTING_LABEL = 'Existing';

export const SMALL_UPS_EDIT_STATUS_NEW_LABEL = 'New';

export const SMALL_UPS_EDIT_TYPE_LABEL = 'Small UPS type';

/** Display labels for {@link FormTwoOptionChoice} — map to `status` existing | new. */
export const SMALL_UPS_EDIT_TYPE_OPTIONS = [
  SMALL_UPS_EDIT_STATUS_EXISTING_LABEL,
  SMALL_UPS_EDIT_STATUS_NEW_LABEL,
] as const;

export const SMALL_UPS_EDIT_DELETE_LABEL = 'Delete';

export const SMALL_UPS_EDIT_SAVE_LABEL = 'Save Small UPS';

/** Create Request / draft flow — clarifies save is local to the step list. */
export const SMALL_UPS_EDIT_SAVE_DRAFT_LABEL = 'Save Small UPS';

export const SMALL_UPS_EDIT_SAVE_DRAFT_HINT =
  'Adds this unit to the list. Save the request separately when ready.';

export const SMALL_UPS_ROW_ACTION_EDIT_LABEL = 'Edit';

export const SMALL_UPS_ROW_ACTION_VIEW_LABEL = 'View';

export const SMALL_UPS_ROW_ACTION_DUPLICATE_LABEL = 'Duplicate';

/** List row overflow menu — short action labels (editor footer uses {@link SMALL_UPS_EDIT_DELETE_LABEL}). */
export const SMALL_UPS_ROW_ACTION_DELETE_LABEL = 'Delete';

export const SMALL_UPS_DELETE_CONFIRM_TITLE = 'Delete Small UPS Configuration';

export const SMALL_UPS_DELETE_CONFIRM_MESSAGE =
  'Are you sure you want to delete this small UPS configuration? This cannot be undone.';

export const SMALL_UPS_DISCARD_UNSAVED_TITLE = 'Unsaved Changes';

export const SMALL_UPS_DISCARD_UNSAVED_MESSAGE =
  'You have unsaved changes. Discard them?';

export const SMALL_UPS_DISCARD_UNSAVED_KEEP_EDITING_LABEL = 'Stay';

export const SMALL_UPS_DISCARD_UNSAVED_DISCARD_LABEL = 'Discard';
